import { useGetOrganizationsQuery } from "../organizationsSlice";

const useOrganizations = () => {
  const { data: organizations, ...rest } = useGetOrganizationsQuery();
  return { organizations, ...rest };
};

export default useOrganizations;
